import React from "react";


const ImageCellRenderer = (props: any) => {
    //console.log(props);


    const onClickLink = () => {
        const image_window: any = window.open(props.data.lastImageUrl, "_blank", 'toolbar=0,location=0,menubar=0');
        image_window.document.write(`
      <html>
        <head>
        </head>
        <body>
          <img src=${props.data.lastImageUrl} alt="Img" height="100%" width="100%">
        </body>
      </html>`);
        // console.log(props.data.lastImageUrl);

        // props.editAction("ShowImage", props.data);
    }
    return (
        <div className={"cellRenderHeader"}>
            <a><span onClick={onClickLink} className={"cellRender"}>{props && props.value}</span></a>
        </div>

    )
}

export default ImageCellRenderer;
